import Model, { attr, belongsTo } from '@ember-data/model';

export default class ClaimSubmissionModel extends Model {
  @belongsTo('insurance-claim', { async: false, inverse: 'currentSubmission' }) insuranceClaim;

  @attr('moment') createdAt;
}
